<!--
    Component: APIResultViewer
    This component show the result of a request to api.
    If data is:
        0: Not shows nothing
        1: Loading bar shown
        Other: The value of 'data' prop is considered a array of errors
-->
<template>
    <div v-if="status !== 0">
        <v-progress-linear
                v-if="status === 1"
                color="primary"
                indeterminate
        ></v-progress-linear>
        <api-errors-viewer :errors="data" v-if="status === 2"></api-errors-viewer>
    </div>
</template>

<script>
    import ApiErrorsViewer from './APIErrorsViewer'
    export default {
        name: "ApiResultViewer",
        data() {
           return {
               status_internal: false,
           }
        },
        props: ['data'],
        computed: {
            status() {
                if(parseInt(this.data) === 0) return 0
                if(parseInt(this.data) === 1) return 1
                return 2
            }
        },
        components: {
            ApiErrorsViewer
        }
    }
</script>

<style scoped>
</style>
